import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userState: false,
        userData: '',
        userToken: '',
        settings_website:[],
        InternalSettings:[],
        userTeam:[],
    },
    plugins: [new VuexPersistence().plugin],
    mutations: {
        editUserState(state, e) {
            state.userState = e;
        },
        getUserData(state, e) {
            state.userData = e;
        },
        getUserToken(state, e) {
            state.userToken = e;
        },
       get_userTeam(state, e) {
            state.userTeam = e;
        },
    },
    getters: {
        token(state) {
            return state.userToken
        },
        organizer_id(state) {
            return state.InternalSettings[0].organizer_id;
        },
        get_user_data(state) {
            return state.userData;
        }
    },
    modules: {}
})
